import React from 'react';
import DynaModal from "../Modal/DynaModal";

const ModalCheckOut = ({onClose, setRequestSmallModal, setShowSmallModal}) => {

    return (

        <DynaModal onClose={onClose} className={'small-modal'}>

            <div className="content-modal ">

                <p>از اتمام پیگیری مطمئن هستید ؟</p>

                <div className="row-button">
                    <button className="cancel-saden-modal" onClick={() => setShowSmallModal(false)}>خیر</button>
                    <button className="accept-saden-modal"
                            onClick={() => setRequestSmallModal(Math.random())}>بله</button>
                </div>

            </div>
        </DynaModal>
    );
};
export default ModalCheckOut;